// 引入vue框架
import { resolve } from 'core-js/es6/promise'
import Vue from 'vue'
// 引入vue-router路由依赖
import Router from 'vue-router'

// Vue全局使用Router
Vue.use(Router)

// 定义路由配置
export default new Router({
	routes: [{ //首页
			path: '/',
			component: resolve => require(['@/view/index'], resolve),
		},
		{ //注册
			path: '/register',
			component: resolve => require(['@/view/register'], resolve),
		},
		{ //登录
			path: '/login',
			component: resolve => require(['@/view/login'], resolve),
		},
		{ //登录
			path: '/logins',
			component: resolve => require(['@/view/login'], resolve),
		},
		{ //找回密码
			path: '/changePassword',
			component: resolve => require(['@/view/changePassword'], resolve),
		},
		{ //交流中心详情
			path:'/Bigcoffeegatheringdetails',
			component: resolve => require(['@/view/details/Bigcoffeegathering/Bigcoffeegatheringdetails.vue'], resolve),
		},
		{ //vr地图
			path:'/vradress',
			component: resolve => require(['@/components/vrmapss.vue'], resolve),
		},
		{ //支付
			path:'/zfa',
			component: resolve => require(['@/view/details/Bigcoffeegathering/payGateWay.vue'], resolve),
		},
		{ //专家智库详情
			path:'/Expertthinktankdetails',
			component: resolve => require(['@/view/details/Expertthinktank/Expertthinktankdetails.vue'], resolve),
		},
		{ //求职招聘详情
			path:'/Jobrecruitmentdetails',
			component: resolve => require(['@/view/details/Jobrecruitment/Jobrecruitmentdetails.vue'], resolve),
		},
		{ //通讯详情
			path:'/maillistdetails',
			component: resolve => require(['@/view/details/maillist/maillistdetails.vue'], resolve),
		},
		{ //会员活动详情
			path:'/Membershipactivitiesdetails',
			component: resolve => require(['@/view/details/Membershipactivities/Membershipactivitiesdetails.vue'], resolve),
		},
		{ //VR会员活动详情
			path:'/Vrmembershipactivitiesdetails',
			component: resolve => require(['@/view/details/Membershipactivities/Vrmembershipactivitiesdetails.vue'], resolve),
		},
		{ //appvue
			path:'/Vrindex',
			component: resolve => require(['@/view/details/Membershipactivities/newbox/src/App.vue'], resolve),
		},
		{ //任务大厅详情
			path:'/MissionHalldetails',
			component: resolve => require(['@/view/details/MissionHall/MissionHalldetails.vue'], resolve),
		},
		{ //新品推荐详情
			path:'/NewArrivalsdetails',
			component: resolve => require(['@/view/details/NewArrivals/NewArrivalsdetails.vue'], resolve),
		},
		{ //船舶船型详情
			path:'/ShipchartLibrarydetails',
			component: resolve => require(['@/view/details/ShipchartLibrary/ShipchartLibrarydetails.vue'], resolve),
		},
		{ //VR选型船舶船型详情
			path:'/VrshipchartLibrarydetails',
			component: resolve => require(['@/view/details/ShipchartLibrary/VrshipchartLibrarydetails.vue'], resolve),
		},
		{ //今日视频详情
			path:'/todayvideodetails',
			component: resolve => require(['@/view/details/todayvideo/todayvideodetails.vue'], resolve),
		},
		{ //搜索大全
			path:'/SearchDaquandetails',
			component: resolve => require(['@/view/details/SearchDaquan/SearchDaquandetails.vue'], resolve),
		},
		{ //公告
			path:'/gonggao',
			component: resolve => require(['@/view/details/gonggao/gonggao.vue'], resolve),
		},
		{ //企业VR
			path:'/Vrshow',
			component: resolve => require(['@/view/details/Vrshows/Vrshow.vue'], resolve),
		},
		{ //行业资讯
			path:'/hyzx',
			component: resolve => require(['@/view/details/hyzx'],resolve)
		},
		{ //订单播报
			path:'/ddbb',
			component: resolve => require(['@/view/details/hyzx/ddbb.vue'],resolve)
		},
		{ //船舶工程
			path:'/cbgc',
			component: resolve => require(['@/view/details/hyzx/cbgc.vue'],resolve)
		},
		{ //海洋工程
			path:'/hygc',
			component: resolve => require(['@/view/details/hyzx/hygc.vue'],resolve)
		},
		{ //招标公告
			path:'/zbgg',
			component: resolve => require(['@/view/details/zbgg'],resolve)
		},
		{ //招标公告详情
			path:'/zbggdetail',
			component: resolve => require(['@/view/details/zbgg/detail.vue'],resolve)
		},
		{ //今日要闻
			path:'/jryw',
			component: resolve => require(['@/view/details/hyzx/jryw.vue'],resolve)
		},
		{ //展会会议
			path:'/zhhy',
			component: resolve => require(['@/view/details/zhhy'],resolve)
		},
		{ //报刊期刊
			path:'/bkqk',
			component: resolve => require(['@/view/details/bkqk'],resolve)
		},
		{ //报刊期刊详情
			path:'/bgqkdetail',
			component: resolve => require(['@/view/details/bkqk/detail.vue'],resolve)
		},
		{ //报刊期刊预览
			path:'/pdf',
			component: resolve => require(['@/view/details/bkqk/pdf.vue'],resolve)
		},
		{ //新品推荐详情
			path:'/xptjdetail',
			component: resolve => require(['@/view/details/NewArrivals/detail.vue'],resolve)
		},
		{ //会员详情详情
			path:'/hyhddetail',
			component: resolve => require(['@/view/details/Membershipactivities/hyhddetail.vue'],resolve)
		},
		{ //会员详情详情
			path:'/vrhyhddetail',
			component: resolve => require(['@/view/details/Membershipactivities/vrhyhddetail.vue'],resolve)
		},
		{ //展会会议详情
			path:'/zhhydetail',
			component: resolve => require(['@/view/details/zhhy/detail.vue'],resolve)
		},
		{ //展会会议二级页面
			path:'/zhhyerji',
			component: resolve => require(['@/view/details/zhhy/dierge.vue'],resolve)
		},
		{ //行业资讯详情
			path:'/hyzxdetail',
			component: resolve => require(['@/view/details/hyzx/detail.vue'],resolve)
		},
		{ //交流中心详情
			path:'/dkyjdetail',
			component: resolve => require(['@/view/details/Bigcoffeegathering/detail.vue'],resolve)
		},
		{ //今日视频详情
			path:'/jrspdetail',
			component: resolve => require(['@/view/details/todayvideo/detail.vue'],resolve)
		},
		{ //通讯录详情
			path:'/txldetail',
			component: resolve => require(['@/view/details/maillist/detail.vue'],resolve)
		},
		{ //船舶船型详情
			path:'/chtkdetail',
			component: resolve => require(['@/view/details/ShipchartLibrary/detail.vue'],resolve)
		},
		{ //船舶船型详情
			path:'/vrchtkdetail',
			component: resolve => require(['@/view/details/ShipchartLibrary/vrdetail.vue'],resolve)
		},
		{ //专家智库详情
			path:'/zjzkdetail',
			component: resolve => require(['@/view/details/Expertthinktank/detail.vue'],resolve)
		},
		{ //任务大厅详情
			path:'/rwdtdetail',
			component: resolve => require(['@/view/details/MissionHall/detail.vue'],resolve)
		},
		{ //求职招聘公司详情
			path:'/qzzpdetail',
			component: resolve => require(['@/view/details/Jobrecruitment/detail.vue'],resolve)
		},
		{ //求职招聘者详情
			path:'/qzzpdetailist',
			component: resolve => require(['@/view/details/Jobrecruitment/detaillist.vue'],resolve)
		},
		{ //求职招聘者简历
			path:'/Jobrecruitmentdetailss',
			component: resolve => require(['@/view/details/Jobrecruitment/Jobrecruitmentdetailss.vue'],resolve)
		},
		{ //求职招聘者简历
			path:'/Vrmap',
			component: resolve => require(['@/view/details/VRmap/detail.vue'],resolve)
		},
		{ //企业大全详情
			path:'/qydqdetail',
			component: resolve => require(['@/view/details/qydq/detail.vue'],resolve)
		},
		{ //产品详情
			path:'/cpxq',
			component: resolve => require(['@/view/details/cpxq/index.vue'],resolve)
		},
		{ //产品二级详情
			path:'/cpxqdetail',
			component: resolve => require(['@/view/details/cpxq/detail.vue'],resolve)
		},
		{ //直播互动详情
			path:'/zbhdindex',
			component: resolve => require(['@/view/details/zbhd/detail.vue'],resolve)
		},
		{ //直播互动列表
			path:'/zbhddetail',
			component: resolve => require(['@/view/details/zbhd/index.vue'],resolve)
		},
		{ //企业大全
			path:'/qydq',
			component: resolve => require(['@/view/details/qydq'],resolve)
		},
		{ //个人中心
			path:'/user',
			component: resolve => require(['@/view/user'],resolve),
			children:[
				{ //基础设置
					path:'/user/jcsz',
					component: resolve => require(['@/view/user/jcsz.vue'],resolve)
				},
				{ //企业管理
					path:'/user/qygl',
					component: resolve => require(['@/view/user/qygl.vue'],resolve)
				},
				{ //信息查看
					path:'/user/zndxx',
					component: resolve => require(['@/view/user/zndxx.vue'],resolve)
				},
				{ //认证管理
					path:'/user/rzgl',
					component: resolve => require(['@/view/user/rzgl.vue'],resolve)
				},
				{ //直播互动
					path:'/user/zbhd',
					component: resolve => require(['@/view/user/zbhd.vue'],resolve)
				},
				{ //任务项目管理
					path:'/user/rwxm',
					component: resolve => require(['@/view/user/rwxm.vue'],resolve)
				},
				{ //名片收益管理
					path:'/user/mp',
					component: resolve => require(['@/view/user/mp.vue'],resolve)
				},
				{ //专家智库
					path:'/user/zjzk',
					component: resolve => require(['@/view/user/zjzk.vue'],resolve)
				},
				{ //交流中心
					path:'/user/dkyj',
					component: resolve => require(['@/view/user/dkyj.vue'],resolve)
				},
				{ //视频播放
					path:'/user/spzx',
					component: resolve => require(['@/view/user/spzx.vue'],resolve)
				},
				{ //图库管理
					path:'/user/tkgl',
					component: resolve => require(['@/view/user/tkgl.vue'],resolve)
				},
				{ //行业资讯
					path:'/user/hyzx',
					component: resolve => require(['@/view/user/hyzx.vue'],resolve)
				},
				{ //人才招聘
					path:'/user/rczp',
					component: resolve => require(['@/view/user/rczp.vue'],resolve)
				},
				{ //企业二维码展示申请
					path:'/user/ewmzssq',
					component: resolve => require(['@/view/user/ewmzssq.vue'],resolve)
				},
				{ //新品推荐
					path:'/user/xptj',
					component: resolve => require(['@/view/user/xptj.vue'],resolve)
				},
				{ //展会会议
					path:'/user/zh',
					component: resolve => require(['@/view/user/zh.vue'],resolve)
				},
				{ //会员活动
					path:'/user/hyhd',
					component: resolve => require(['@/view/user/hyhd.vue'],resolve)
				},
				{ //收藏
					path:'/user/sc',
					component: resolve => require(['@/view/user/sc.vue'],resolve)
				},
				{ //账户明细
					path:'/user/zhmx',
					component: resolve => require(['@/view/user/zhmx.vue'],resolve)
				},
				{ //国际期刊
					path:'/user/gjqk',
					component: resolve => require(['@/view/user/gjqk.vue'],resolve)
				},
				{ //PPT分享
					path:'/user/pptfx',
					component: resolve => require(['@/view/user/pptfx.vue'],resolve)
				},
				{ //招标通告
					path:'/user/zbtg',
					component: resolve => require(['@/view/user/zbtg.vue'],resolve)
				},
				{ //收益明细
					path:'/user/symx',
					component: resolve => require(['@/view/user/symx.vue'],resolve)
				}
			]
		},
	]
})
